import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import TableBasic from "src/components/DataTable/TableBasic";
import Loader from "src/components/Loader";
import communication from "src/constants/Communication";
import useAxios from "src/hooks/useAxios";
import * as yup from 'yup';
import { Button, Container, Stack, Typography } from "@mui/material";
import Iconify from "src/components/Iconify";
import Page from "src/components/Page";

export default function CertificatesList() {
  const navigate = useNavigate();
  const [searchFields, setSearchFields] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const [paginationProps, setPaginationProps] = useState({
    page: +searchParams.get('page') || 0,
    rowsPerPage: 10,
  });

  // Add options for rows per page
  const rowsPerPageOptions = [10, 25, 50, 100];

  const gridColumns = [
    { id: 'registration.firstName', label: 'Issued To', alignRight: false, type: 'string' },
    { id: 'templateUsed', label: 'Template Used', alignRight: false, type: 'string' },
    { id: 'issueDate', label: 'Issued Date', alignRight: false, type: 'date' },
    { id: 'course', label: 'Course', alignRight: false, type: 'string' },
    { id: 'status', label: 'Status', alignRight: false, type: 'status' },
    { id: 'action', label: 'Action', alignRight: false, type: 'actionbutton' },
  ];

  const finalParams = {
    limit: paginationProps.rowsPerPage,
    page: paginationProps.page + 1,
    searchCriteria: searchFields,
    sortBy: 'issueDate:desc',
  };

  console.log("🟦 Axios Params:", finalParams);

  const [data, loading, error] = useAxios({
    url: communication.certificates,
    method: 'GET',
    params: finalParams,
  });

  if (loading || error) return <Loader />;

  const search = (values) => {
    const searchFilter = {}
    for (let key of Object.keys(values)) {
        if (values[key] != '') {
            searchFilter[key] = values[key]

        }
    }

    setSearchFields(searchFilter)
    setPaginationProps({
      page: 0,
      rowsPerPage: 10,
    });
    setSearchParams({ page: 0 });
}

  const handleChangePage = (event, newPage) => {
    setPaginationProps((prev) => ({ ...prev, page: newPage }));
    setSearchParams({ page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setPaginationProps({
      page: 0,
      rowsPerPage: parseInt(event.target.value, 10),
    });
  };

  const searchCriteria = {
    initialValues: {
      registration: '',
      course: '',
      status: '',
    },
    searchCallback: search,
    filterCritera: {
      registration: {
        type: 'text',
        name: 'name',
        label: 'Issued To / Student Name'
      },
      course: {
        type: 'text',
        name: 'course',
        label: 'Course'
      },
      status: {
        type: 'select',
        name: 'status',
        label: 'Status',
        options: [
          { value: 'unverified', name: 'Unverified' },
          { value: 'verified', name: 'Verified' },
          { value: 'published', name: 'Published' },
          { value: 'expired', name: 'Expired' },
          { value: 'revoked', name: 'Revoked' }
        ]
      },
    },
    validationSchema: yup.object({
      registration: yup.string(),
      course: yup.string(),
      status: yup.string(),
    })
  };

  const gridData = data?.results?.map((item) => ({
    ...item,
    action: {
      url: '/certificates/' + item.id,
    }
  })) || [];

  return (
    <Page title="Certificates">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Certificates
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => navigate('/certificates/create')}
          >
            New Certificate
          </Button>
        </Stack>

        <TableBasic
          tableName="Certificates"
          gridData={gridData}
          gridColumns={gridColumns}
          searchCriteria={searchCriteria}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={paginationProps.page}
          count={data ? data.totalResults : 0}
          rowsPerPage={paginationProps.rowsPerPage}
          rowsPerPageOptions={rowsPerPageOptions}
        />
      </Container>
    </Page>
  );
}
